var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#3671B2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.63 15.8333C17.7 16.8717 17.875 17.8867 18.155 18.855L16.755 20.255C16.2767 18.855 15.9733 17.3733 15.8683 15.8333H17.63ZM29.1333 29.8567C30.125 30.1367 31.14 30.3117 32.1667 30.3817V32.12C30.6267 32.015 29.145 31.7117 27.7333 31.245L29.1333 29.8567ZM18.75 13.5H14.6667C14.025 13.5 13.5 14.025 13.5 14.6667C13.5 25.6217 22.3783 34.5 33.3333 34.5C33.975 34.5 34.5 33.975 34.5 33.3333V29.2617C34.5 28.62 33.975 28.095 33.3333 28.095C31.8867 28.095 30.475 27.8617 29.1683 27.43C29.0517 27.3833 28.9233 27.3717 28.8067 27.3717C28.5033 27.3717 28.2117 27.4883 27.9783 27.71L25.4117 30.2767C22.11 28.585 19.4033 25.89 17.7233 22.5883L20.29 20.0217C20.6167 19.695 20.71 19.24 20.5817 18.8317C20.15 17.525 19.9167 16.125 19.9167 14.6667C19.9167 14.025 19.3917 13.5 18.75 13.5Z",
    fill: "#F6F6F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.a4144ee85715eba2c880128ff6e9be61.svg";
export { ForwardRef as ReactComponent };